import React from 'react';
import type { IAttribute, IItem } from '../types';

export function useGroupAttributes(cardData: IItem[], attributes: IAttribute[]) {
  const groupAttributes = React.useMemo(() => {
    // attributes group id for download category
    const pimAttrGroup = cardData?.[0]?.pimAttrGroup || '';
    const excludedAttributes = ['dfAttributeDfFileType', 'dfAttributeDfFileSize'];
    const children =
      attributes.find((attribute) => attribute.pimId === pimAttrGroup)?.children || [];
    // filter data for download group attributes
    const cardAttributes = children.filter((attr) =>
      cardData?.some((el) => el?.[attr.facetname] !== undefined),
    );

    // exclude file size and type from attributes
    return cardAttributes.filter((attr) => !excludedAttributes.includes(attr.facetname));
  }, [cardData, attributes]);

  return groupAttributes;
}
